import "./section_title.css";

function SectionTitle({ text, color = "orange", className = "" }) {
    return (
        <div className={`section-title-container ${className}`}>
            <h2 className={`section-title ${color}`}>
                {text}
            </h2>
        </div>
    );
}

export default SectionTitle;
